import React from 'react';
import { FiInfo } from 'react-icons/fi';
import { useLanguage } from './LanguageContext';
import './ComplianceNotice.css';

const COPY = {
  en: {
    title: 'Educational modeling notice',
    body: 'This platform provides educational information, financial modeling tools, and scenario analysis. It does not provide personalized financial advice, investment recommendations, tax advice, legal advice, or retirement advice.',
    compactBody: 'Hamilton Services provides educational modeling and tools to help you understand your options.',
    compactFooter: 'This is educational modeling, not financial advice.',
    footer: 'Please consult qualified professionals before making financial decisions.',
  },
  fr: {
    title: "Avis de modélisation éducative",
    body: "Cette plateforme fournit des informations éducatives, des outils de modélisation financière et des analyses de scénarios. Elle ne fournit pas de conseils financiers personnalisés, de recommandations d'investissement, de conseils fiscaux, de conseils juridiques ou de conseils de retraite.",
    compactBody: 'Hamilton Services fournit des outils de modélisation éducative pour vous aider à comprendre vos options.',
    compactFooter: 'Il s’agit de modélisation éducative, pas de conseils financiers.',
    footer: 'Veuillez consulter des professionnels qualifiés avant de prendre des décisions financières.',
  },
};

const ComplianceNotice = ({ compact = false, className = '' }) => {
  const { lang } = useLanguage();
  const c = COPY[lang] || COPY.en;

  return (
    <section className={`compliance-notice ${compact ? 'compact' : ''} ${className}`.trim()} role="note" aria-label={c.title}>
      {compact ? (
        <>
          <span className="compliance-notice-icon"><FiInfo /></span>
          <p>
            {c.compactBody}{' '}
            <strong>{c.compactFooter}</strong>
          </p>
        </>
      ) : (
        <>
          <h3>{c.title}</h3>
          <p>{c.body}</p>
          <p className="compliance-notice-footer">{c.footer}</p>
        </>
      )}
    </section>
  );
};

export default ComplianceNotice;
